"use client";

import { CheckCircleIcon } from "@chakra-ui/icons";
import { HStack, Icon, Text, VStack } from "@chakra-ui/react";

const ValueBlock = ({ title, description }: { title: string; description: string }) => {
  return (
    <HStack alignItems="flex-start" gap="16px">
      <Icon as={CheckCircleIcon} color="brand.primary" mt="6px" />
      <VStack alignItems="flex-start">
        <Text fontSize="20px" fontWeight="700" color="brand.secondary">
          {title}
        </Text>
        <Text
          fontWeight="500"
          fontSize="16px"
          lineHeight="24px"
          pb="24px"
          borderBottom="1px dashed"
          borderColor="brand.secondary"
        >
          {description}
        </Text>
      </VStack>
    </HStack>
  );
};

export default ValueBlock;
